import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { ArrowLeft, Loader2, MailCheck } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { AuthShell, apiError } from '../components/auth/AuthShell';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sentMsg, setSentMsg] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/forgot-password`, { email });
      setSentMsg(res.data.message);
    } catch (err) {
      toast.error(apiError(err, 'İstek gönderilemedi'));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Şifremi Unuttum" description="E-posta adresinizi girin, size şifre sıfırlama bağlantısı gönderelim." testId="forgot-password-page">
      {sentMsg ? (
        <div className="space-y-4" data-testid="forgot-password-sent">
          <div className="flex gap-3 rounded-lg border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-800">
            <MailCheck className="h-5 w-5 shrink-0" />
            <p>{sentMsg} Bağlantı 1 saat geçerlidir. Gelen kutunuzu ve gereksiz klasörünü kontrol edin.</p>
          </div>
          <Button variant="outline" className="w-full" onClick={() => setSentMsg('')} data-testid="forgot-password-retry">Tekrar Gönder</Button>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="forgot-email">E-posta</Label>
            <Input id="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="ornek@email.com" required data-testid="forgot-password-email" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-slate-900 hover:bg-slate-800" data-testid="forgot-password-submit">
            {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Sıfırlama Bağlantısı Gönder
          </Button>
        </form>
      )}
      <Link to="/login" className="mt-6 flex items-center justify-center gap-1 text-sm text-slate-600 hover:text-slate-900" data-testid="forgot-password-back">
        <ArrowLeft className="h-4 w-4" />Giriş ekranına dön
      </Link>
    </AuthShell>
  );
}
